import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LenisProvider from '@/components/LenisProvider';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import AdminRoute from '@/components/AdminRoute';
import LandingPage from '@/pages/LandingPage';
import Register from '@/pages/Register';
import Track from '@/pages/Track';
import AdminLogin from '@/pages/AdminLogin';
import AdminDashboard from '@/pages/AdminDashboard';
import ScoreboardPage from '@/pages/ScoreboardPage';
import '@/App.css';

function Shell({ children, chromeless }) {
  if (chromeless) return <>{children}</>;
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}

function AppRouter() {
  const loc = useLocation();
  const chromeless = loc.pathname.startsWith('/admin');
  return (
    <Shell chromeless={chromeless}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/track" element={<Track />} />
        <Route path="/live" element={<ScoreboardPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LenisProvider>
          <AppRouter />
          <Toaster position="bottom-right" theme="dark" />
        </LenisProvider>
      </BrowserRouter>
    </div>
  );
}
